module.exports = __webpack_public_path__ + "ec1dfc0a98922bc6e52b72c0b2158220.ttf";